export const reviewerInitialState = {
    reviewer: null,
    isLoading: true,
}